import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import DstButton from "../../../../components/DstButton/DstButton";
import Popup from "../../../../components/Popup/Popup";
import { formatDateHumanly } from "../../../../services/TimeService";
import translate from "../../../../services/Translate";
import { DemoRecordPopupProps } from "./DemoRecordPopup.d";

const DemoRecordPopup = ({ show, onClose, demo, language }: DemoRecordPopupProps) => {
  return (
    <Popup show={show} onClose={onClose} modalTitle={demo?.name} size="lg" scrollable>
      {demo && (
        <Card className="border-0" id="demo-record-popup">
          <Card.Body>
            <Row>
              <Col>
                <div className="text-muted">{translate(language, "PAGES.DEV.DEMO_RECORDS.AUTHOR")}</div>
                <div>
                  {demo?.author && (
                    <Link to={`/user/${demo.author.id}`} className="text-decoration-none">
                      {demo.author.full_name}
                    </Link>
                  )}
                </div>
              </Col>
              <Col>
                <div className="text-muted">{translate(language, "PAGES.DEV.DEMO_RECORDS.CREATED_DATE")}</div>
                <div>{formatDateHumanly(language, demo.dt_created)}</div>
              </Col>
            </Row>
            <hr className="my-4" />
            {demo?.description && <p className="m-regular text-pre-line">{demo.description}</p>}
            <div className="d-flex flex-wrap gap-2 mt-3">
              {demo.documents_link && (
                <DstButton
                  value={translate(language, "PAGES.DEV.DEMO_RECORDS.DOCUMENTS_LINK")}
                  variant="primary"
                  btnClass="m-regular"
                  target="_blank"
                  clickFunction={() => window.open(demo.documents_link!, "_blank")}
                />
              )}
              {demo.record_link && (
                <DstButton
                  value={translate(language, "PAGES.DEV.DEMO_RECORDS.RECORD_LINK")}
                  variant="primary"
                  btnClass="m-regular"
                  target="_blank"
                  clickFunction={() => window.open(demo.record_link!, "_blank")}
                />
              )}
              {demo.slide_link && (
                <DstButton
                  value={translate(language, "PAGES.DEV.DEMO_RECORDS.SLIDE_LINK")}
                  variant="primary"
                  btnClass="m-regular"
                  target="_blank"
                  clickFunction={() => window.open(demo.slide_link!, "_blank")}
                />
              )}
            </div>
          </Card.Body>
        </Card>
      )}
    </Popup>
  );
};

export default DemoRecordPopup;
